import script from "./TransfertsContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransfertsContent.vue?vue&type=script&setup=true&lang=ts"

import "./TransfertsContent.vue?vue&type=style&index=0&id=22f1a93e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f1a93e"]])

export default __exports__